export const plansPathFor = (brokerageId, seatUserIds = []) => {
  const params = new URLSearchParams({ tab: "plans", plan: "brokerage" });
  if (brokerageId) params.set("brokerage", String(brokerageId));
  const ids = seatUserIds.filter(Boolean);
  if (ids.length) params.set("seats", ids.join(","));
  return `/settings?${params.toString()}`;
};
